import React, { FC, useContext } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { parseISO } from 'date-fns';

// Components
import BaseContentContainer from '../../components/base-content-container/base-content-container';
import ButtonsBar from '../../components/buttons-bar/buttons-bar';
import Infos from '../../components/infos/infos';
import SubmitButton from '../../components/submit-button/submit-button';

// Helpers
import {
  backofficeRecipientsToEngagementRows,
  deleteGallery,
  exhibitionOnToDate,
  filesToImagePreviewList,
} from '../../helpers/gallery-helper';

// Models
import {
  BaseContentContainerActionButtonPosition,
  BaseContentContainerBiggerSide,
  BaseContentContainerFormat,
} from '../../models/base-content-container';

// Providers
import { GeneralContext } from '../../providers/general-provider';

// Services
import GalleryService from '../../services/gallery-service';

const GalleryFollow: FC<{
  gallery: BackofficeGalleryDetailDto;
  galleryService: GalleryService;
}> = ({ gallery, galleryService }) => {
  const navigate = useNavigate();
  const { galleryId } = useParams<{ galleryId: string }>();
  const { setModalContent, setToastContent } = useContext(GeneralContext);

  const galleryData: (InfosData | InfosDataImageList | GalleryDataInfo)[] = [
    {
      type: 'title',
      content: gallery.title,
    },
    {
      type: 'galleryInfo',
      description: gallery.description,
      // Data já resolvida como local (ver exhibitionOnToDate); passar a string
      // crua faria o Infos lê-la como meia-noite UTC e mostrar o dia anterior.
      date: exhibitionOnToDate(gallery.exhibitionOn) || parseISO(gallery.createdAt.local),
    },
    {
      type: 'imageList',
      content: filesToImagePreviewList(gallery.files),
    },
  ];

  // O engajamento de galeria tem dois estados (`seen`), sem a distinção
  // visualizado x lido dos comunicados, então a tabela tem uma coluna de status.
  const engagementData: InfosDataList = {
    type: 'list',
    content: {
      titles: [
        {
          text: 'Aluno',
        },
        {
          text: 'Turma',
        },
        {
          text: 'Responsável',
        },
        {
          text: 'Visualizados',
          customStyle: { textAlign: 'center' },
        },
      ],
      rows: backofficeRecipientsToEngagementRows(gallery.recipients),
    },
  };

  return (
    <BaseContentContainer
      format={BaseContentContainerFormat.doubleWithActionButtons}
      withoutShadowBox={true}
      biggerSide={BaseContentContainerBiggerSide.right}
      actionButtonPosition={BaseContentContainerActionButtonPosition.bottom}
    >
      <Infos
        title='galeria enviada'
        titleColor='intermediate'
        data={galleryData}
      />
      <Infos
        title='engajamento'
        titleColor='curiosity'
        backgroundColor='gray'
        data={engagementData}
      />
      <ButtonsBar pattern='firstSeparate' verticalAlign='bottom'>
        <Link to='/galerias/listar'>
          <SubmitButton value='cancelar' variant='terciary' />
        </Link>
        <div>
          <SubmitButton
            value='deletar'
            variant='terciary'
            onClick={() =>
              deleteGallery(
                galleryService,
                galleryId,
                setModalContent,
                setToastContent,
                navigate
              )
            }
          />
          <Link to={`/galerias/${galleryId}/editar`}>
            <SubmitButton value='editar' variant='primary' />
          </Link>
        </div>
      </ButtonsBar>
    </BaseContentContainer>
  );
};

export default GalleryFollow;
